import React from 'react';
import {
  Typography,
} from '@mui/material';
import PersonalInfo from './PersonalInfo';
import CompanyDetails from './CompanyDetails';
import Employment from './Employment';
import TeamsSection from './TeamsSection';
import ProjectsRole from './ProjectsRole';
import TabTitle from './TabTitle';
import PayBill from './PayBill';
import WorkTimeLimits from './WorkTimeLimits';
import MemberProfileSettings from './MemberProfileSettings';

const UserProfileTabsContent = ({ activeTab, menuItems }) => {
  switch (activeTab) {
    case 0:
      return (
        <>
          <TabTitle title="PERSONAL INFO" />

          <PersonalInfo />
        </>
      );

    case 1:
      return (
        <>
          <TabTitle title="COMPANY" />

          <CompanyDetails />

        </>
      );

    case 2:
      return (
        <>
          <TabTitle title="EMPLOYMENT" />

          <Employment />
        </>
      );

    case 3:
      return (
        <>
          <TabTitle title="TEAMS" />
          <TeamsSection />

        </>
      );

    case 4:
      return (
        <>
          <TabTitle title="PROJECTS & ROLES" />

          <ProjectsRole />
        </>
      );

    case 5:
      return (
        <>
          <TabTitle title="PAY / BILL" />
          <PayBill />

        </>
      );

    case 6:
      return (
        <>
          <TabTitle title="WORK TIME & LIMITS" />
          <WorkTimeLimits />

        </>
      );

    case 7:
      return (
        <>
          <TabTitle title="SETTINGS" />
          <MemberProfileSettings />
        </>
      );

    default:
      return (
        <Typography variant="body1" color="text.secondary">
          <TabTitle title={menuItems[activeTab] || 'Details'} />
        </Typography>
      );
  }
};

export default UserProfileTabsContent;
